module.exports = __webpack_public_path__ + "img/13.bbd497d5.jpg";